export default __webpack_public_path__ + "static/media/model_confusion_matrix.0ced2898.png";